import { gql } from "@apollo/client";

export const GET_JUSTIFICACION_BY_EVALUACION_ID = gql`
query evaluacionById($idEvaluacion: Int!) {
    evaluacionById(idEvaluacion: $idEvaluacion) {
        evaluacion{
            idPaciente
            idMedioEnvio
            idResultadoPresupuesto
            fechaEnvioPresupuesto
            fechaResultadoPresupuesto
            numeroImpresionesPresupuesto
            numeroSeguimiento
            observacionPresupuesto
            t_Justificacion_Condicional {
                idJustificacion
                tipoJustificacion
                idEvaluacion
                idOrdenPedido
                diasCondiContrato
                diasMaxFactCliente
                estadoPEnvio
                justificadoMedico
                justificadoComercial
                obsComercial
                obsMedico
                fechaMedico
                fechaComercial
                fechaAlta
                contratosCO
                obsBUM
                idUsuarioBUM
                fechaBUM
                justificadoBUM
                idEstadoComercial
                idEstadoMedico
                idEstadoBUM
                idUsuarioMedicoNavigation {
                    nombre,
                    apellido
                },
                idUsuarioComercialNavigation {
                    nombre,
                    apellido
                }
            }
            idPacienteNavigation{
                nombre
                apellido
            }
        }
    }
}`;

export const adaptJustificacion = (evaluacionById) => {
  const { evaluacion, derivacionPrescriptor } = evaluacionById;

  const justificacion = evaluacion?.t_Justificacion_Condicional?.
  filter((x) => x.tipoJustificacion === "CONTRATO")?.
  at(-1) ?? null;

  return {
    idMedioEnvio: evaluacion?.idMedioEnvio,
    idResultadoPresupuesto: evaluacion?.idResultadoPresupuesto,
    fechaEnvioPresupuesto: evaluacion?.fechaEnvioPresupuesto,
    fechaResultadoPresupuesto: evaluacion?.fechaResultadoPresupuesto,
    numeroAprobacionPresupuesto: evaluacion?.numeroImpresionesPresupuesto,
    numeroSeguimiento: evaluacion?.numeroSeguimiento,
    observacion: evaluacion?.observacionPresupuesto,
    idJustificacion: justificacion?.idJustificacion,
    tipoJustificacion: justificacion?.tipoJustificacion,
    idOrdenPedido: justificacion?.idOrdenPedido,
    diasCondiContrato: justificacion?.diasCondiContrato,
    diasMaxFactCliente: justificacion?.diasMaxFactCliente,
    estadoPEnvio: justificacion?.estadoPEnvio,
    //TODO: cambiar id 1 cuando este vacio por el id correspondiente al estado pendiente
    justificacionMedico: justificacion?.justificadoMedico !== null ? parseInt(justificacion?.justificadoMedico) : 1,
    justificacionComercial: justificacion?.justificadoComercial !== null ? parseInt(justificacion?.justificadoComercial) : 1,
    observacionComercial: justificacion?.obsComercial,
    observacionMedico: justificacion?.obsMedico,
    usuarioJustificacionComercial: !justificacion?.idUsuarioComercialNavigation ? "" :
    justificacion?.idUsuarioComercialNavigation?.nombre + ' ' + justificacion?.idUsuarioComercialNavigation?.apellido,
    usuarioJustificacionMedico: !justificacion?.idUsuarioMedicoNavigation ? "" :
    justificacion?.idUsuarioMedicoNavigation?.nombre + ' ' + justificacion?.idUsuarioMedicoNavigation?.apellido,
    fechaJustificacionMedico: justificacion?.fechaMedico,
    fechaJustificacionComercial: justificacion?.fechaComercial,
    fechaAlta: justificacion?.fechaAlta,
    contratosCO: justificacion?.contratosCO,
    fechaBUM: justificacion?.fechaBUM,
    justificadoBUM: justificacion?.justificadoBUM,
    idEstadoComercial: justificacion?.idEstadoComercial !== null ? parseInt(justificacion?.idEstadoComercial) : 1,
    idEstadoMedico: justificacion?.idEstadoMedico !== null ? parseInt(justificacion?.idEstadoMedico) : 1,
    idEstadoBUM: justificacion?.idEstadoBUM
  };
};